<app-sp-page-error (pageButtonClick)="onButtonClick()" title="403" subtitle="Access forbidden" buttonText="Back to home" [imageType]="ImageType.DENIED">
  <p>Sorry but you don’t have<br class="d-block d-sm-none" /> permission to access this page.<br /> If you think this is a mistake, contact your admin.</p>
</app-sp-page-error>
